import React from 'react'
import Footer from '../Footer';
import Header from '../Header';
import Servicedata from '../Api/service';

function Creditcardswipeservice() {
    

    return (
        <>
          <Header />

            <section className="hero-section">
                <div className="container">
                    <div className="row align-items-center">
                        <h1 className="text-white">Credit Card Swipe</h1>
                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container">
                    <div className="container section-title" data-aos="fade-up">
                        <div className="d-flex justify-content-center">
                            <button
                                type="button"
                                className="btn btn-light rounded-pill"
                            >
                                SERVICES
                            </button>
                        </div>
                        <h1 style={{ textAlign: 'center' }}>
                            <span>Credit Card Swipe</span> <span className="link-primary">Service</span>
                        </h1>
                    </div>
                </div>
            </section>
            <section id="about" className="about section light-background">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
                            <div className="about-content ps-0 ps-lg-3">
                                {/* <h3>"Innovation is not just our Strength; it is our Foundation."</h3> */}
                                <p className="fst-italic">
                                <b>Sai Financial Service</b> Provider is committed to offering reliable and efficient credit card swipe services to meet your financial needs. Please read the following content, terms, and conditions carefully:

                                </p>
                                <h3>Service Content:</h3>
                                <ol style={{ listStyle: 'disc' }}>
                                    <li><p className="fst-italic"><b>Credit Card Swipe Assistance:</b> Our service allows you to withdraw money or make payments using your credit card at a 2% service charge on the transaction amount.</p></li>
                                    <li><p className="fst-italic"><b>Secure Transactions:</b> We ensure safe and encrypted processing for every transaction to protect your sensitive data.</p></li>
                                    <li><p className="fst-italic"><b>Service Availability:</b> Expand your business or manage cash flow with our range of business loan options.</p></li>
                                    {/* <li><p className="fst-italic"><b>Vehicle Loans:</b>This service is available for all major credit card networks, including Visa, MasterCard, and RuPay.</p></li>
                                    <li><p className="fst-italic"><b>Loan Against Property:</b>  Unlock the potential of your property to get funds for your business or personal needs.</p></li>
                                    <li><p className="fst-italic"><b>Others Loan:</b> We also provide other loan services like education loans, gold loans, agricultural loans and other loans designed to meet specific financial requirements.</p></li> */}
                                </ol>
                                <h3>Terms & Conditions?</h3>
                                <ol style={{ listStyle: 'disc' }}>
                                    <li><p className="fst-italic"><b>Service Fee:</b> A 2% service charge is applied to every credit card swipe transaction. This charge is exclusive of any applicable taxes or additional bank charges that may apply.</p></li>
                                    <li><p className="fst-italic"><b>Payment Policy:</b> The 2% service fee will be deducted at the time of the transaction. All charges are non-refundable once the transaction is processed.</p></li>
                                    <li><p className="fst-italic"><b>Usage and Limits:</b> The service is subject to the credit limit available on your card. Customers are responsible for ensuring sufficient credit availability before initiating the transaction.</p></li>
                                    <li><p className="fst-italic"><b>Processing Time:</b> Transactions are processed instantly, but delays may occur due to technical issues or banking network downtime.</p></li>
                                    <li><p className="fst-italic"><b>Responsibility for Repayment:</b> The customer is solely responsible for repaying the credit card balance, including the transaction amount and any interest charges levied by their credit card issuer.</p></li>
                                    <li><p className="fst-italic"><b>Confidentiality:</b> All customer information is treated with strict confidentiality and used solely for processing the transaction.</p></li>
                                    <li><p className="fst-italic"><b>Disclaimer:</b> Sai Financial Service Provider is a facilitator and does not assume liability for issues related to bank policies, credit limits, or technical errors outside of our control.</p></li>
                                </ol>
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
                            <img src="assets\images\svg\swipe.png" alt className="h-100 img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="container section-title" data-aos="fade-up">

                        <h1 style={{ textAlign: 'center' }}>
                            <span>Credit Card Swipe</span> <span className="link-primary">Service</span>
                        </h1>
                    </div>
                </div>
            </section>
            <Servicedata/>
            <Footer />
        </>
    )
}

export default Creditcardswipeservice
